import React from 'react'

import { Divider, SecurityNoticeContainer, SecurityNoticeText } from './styled-components'

const SecurityNotice = () => (
  <SecurityNoticeContainer>
    <SecurityNoticeText>Acorns Spend accounts are FDIC insured up to $250,000.</SecurityNoticeText>

    <Divider />

    <SecurityNoticeText>
      Acorns Invest & Later are SIPC insured/protected up to $500,000.
    </SecurityNoticeText>
  </SecurityNoticeContainer>
)

export default SecurityNotice
